<div class="dx-card p-4">
  <!-- <div class="blah">
    <dx-button
      stylingMode="text"
      (onClick)="onCollapseAll()"
      type="default"
      icon="chevronright"
      hint="{{ 'Alle Gruppen schliessen' | translate }}"
    ></dx-button>
    <dx-button
      stylingMode="text"
      (onClick)="onExpandAll()"
      type="default"
      icon="chevrondown"
      hint="{{ 'Alle Gruppen öffnen' | translate }}"
    ></dx-button>
    <dx-button
      [visible]="canView('refreshButton')"
      stylingMode="text"
      type="default"
      text="{{ 'Aktualisieren' | translate }}"
      (onClick)="refresh()"
      hint="{{ 'Katalogliste aktualisieren' | translate }}"
    ></dx-button>
    <dx-button
      [visible]="canView('importButton')"
      stylingMode="text"
      type="default"
      text="{{ 'Importieren' | translate }}"
      (onClick)="showImportCatalog()"
      hint="{{ 'Katalog hochladen (Excel, BMEcat)' | translate }}"
    ></dx-button>
    <dx-button
      *ngIf="!isDataProcessContainer"
      [visible]="canView('newCatalogButton')"
      stylingMode="text"
      type="default"
      text="{{ 'Neuer Katalog' | translate }}"
      (onClick)="showAddCatalog()"
      hint="{{ 'Neuen, leeren Katalog anlegen' | translate }}"
    ></dx-button>
    <dx-button
      *ngIf="!isDataProcessContainer && copyCatalogId != ''"
      stylingMode="text"
      type="default"
      text="Katalog einfügen"
      (onClick)="pasteCatalog()"
      hint="{{ 'Katalog einfügen' | translate }}"
    ></dx-button>
    <dx-button
      stylingMode="text"
      type="default"
      text="{{ 'JobFiles' | translate }}"
      (click)="showJobData()"
      *ngIf="loginService.isAdmin"
      title="JobData"
    ></dx-button>
    <dx-button
      [visible]="canView('backupButton')"
      stylingMode="text"
      type="default"
      text="{{ 'Backups' | translate }}"
      (click)="showBackUp()"
      title="BackUps"
      hint="{{ 'Vorhandene Backups anzeigen' | translate }}"
    ></dx-button>
  </div> -->
  <dx-button icon="edit" (onClick)="onEdit($event)">Edit</dx-button>
  <div class="p-4 dx-card d-inline-flex gap-4">
    <ng-content></ng-content>
  </div>
</div>
